module.exports = __webpack_public_path__ + "img/sr.89a447af.svg";